import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKey =
	| 'collection'
	| 'confluence'
	| 'confluenceCallout'
	| 'decision'
	| 'epic'
	| 'finding'
	| 'graphLabel'
	| 'jira'
	| 'jiraCallout'
	| 'loom'
	| 'loomCallout'
	| 'meetingRecording'
	| 'new'
	| 'page'
	| 'project'
	| 'ready'
	| 'rovo'
	| 'rovoCallout'
	| 'skip'
	| 'team'
	| 'teamwork'
	| 'welcome'
	| 'welcomeWithName'
	| 'you';

export const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
	welcome: {
		id: 'twcg-onboarding-intro-animation.welcome',
		defaultMessage: 'Welcome to Teamwork Collection',
		description: 'Heading for the Teamwork Collection onboarding intro animation.',
	},
	welcomeWithName: {
		id: 'twcg-onboarding-intro-animation.welcomeWithName',
		defaultMessage: 'Welcome to Teamwork Collection, {userName}',
		description: 'Personalized heading for the Teamwork Collection onboarding intro animation.',
	},
	finding: {
		id: 'twcg-onboarding-intro-animation.finding',
		defaultMessage: 'Teamwork Graph is finding you and your apps…',
		description: 'Status shown while the intro animation finds the user and their apps.',
	},
	ready: {
		id: 'twcg-onboarding-intro-animation.ready',
		defaultMessage: "We've analyzed your work. Here's the best place to start.",
		description: 'Status shown when the intro animation has finished analyzing work.',
	},
	graphLabel: {
		id: 'twcg-onboarding-intro-animation.graphLabel',
		defaultMessage: 'Your Teamwork Graph',
		description: 'Accessible label for the animated teamwork graph.',
	},
	skip: {
		id: 'twcg-onboarding-intro-animation.skip',
		defaultMessage: 'Skip animation',
		description: 'Accessible label for the button that skips the intro animation.',
	},
	you: {
		id: 'twcg-onboarding-intro-animation.you',
		defaultMessage: 'You',
		description: 'Label for the current user in the teamwork graph.',
	},
	new: {
		id: 'twcg-onboarding-intro-animation.new',
		defaultMessage: 'New',
		description: 'Label for a newly available app in the teamwork graph.',
	},
	confluenceCallout: {
		id: 'twcg-onboarding-intro-animation.confluenceCallout',
		defaultMessage: 'Create docs that stay connected to your work with Rovo',
		description: 'Benefit callout shown when Confluence joins the teamwork graph.',
	},
	jiraCallout: {
		id: 'twcg-onboarding-intro-animation.jiraCallout',
		defaultMessage: 'Plan and track work with agents',
		description: 'Benefit callout shown when Jira joins the teamwork graph.',
	},
	loomCallout: {
		id: 'twcg-onboarding-intro-animation.loomCallout',
		defaultMessage: 'Record voice & video to give Rovo and your agents richer context',
		description: 'Benefit callout shown when Loom joins the teamwork graph.',
	},
	rovoCallout: {
		id: 'twcg-onboarding-intro-animation.rovoCallout',
		defaultMessage: '10x more Rovo credits for your team and agents',
		description: 'Benefit callout shown when Rovo joins the teamwork graph.',
	},
	teamwork: {
		id: 'twcg-onboarding-intro-animation.teamwork',
		defaultMessage: 'Teamwork',
		description: 'Teamwork wordmark text shown above the intro heading.',
	},
	collection: {
		id: 'twcg-onboarding-intro-animation.collection',
		defaultMessage: 'Collection',
		description: 'Collection label shown next to the Teamwork wordmark.',
	},
	confluence: {
		id: 'twcg-onboarding-intro-animation.confluence',
		defaultMessage: 'Confluence',
		description: 'Confluence product name shown in the teamwork graph.',
	},
	jira: {
		id: 'twcg-onboarding-intro-animation.jira',
		defaultMessage: 'Jira',
		description: 'Jira product name shown in the teamwork graph.',
	},
	loom: {
		id: 'twcg-onboarding-intro-animation.loom',
		defaultMessage: 'Loom',
		description: 'Loom product name shown in the teamwork graph.',
	},
	rovo: {
		id: 'twcg-onboarding-intro-animation.rovo',
		defaultMessage: 'Rovo',
		description: 'Rovo product name shown in the teamwork graph.',
	},
	project: {
		id: 'twcg-onboarding-intro-animation.project',
		defaultMessage: 'Project',
		description: 'Project node label shown in the teamwork graph.',
	},
	epic: {
		id: 'twcg-onboarding-intro-animation.epic',
		defaultMessage: 'Epic',
		description: 'Epic node label shown in the teamwork graph.',
	},
	decision: {
		id: 'twcg-onboarding-intro-animation.decision',
		defaultMessage: 'Decision',
		description: 'Decision node label shown in the teamwork graph.',
	},
	meetingRecording: {
		id: 'twcg-onboarding-intro-animation.meetingRecording',
		defaultMessage: 'Meeting recording',
		description: 'Meeting recording node label shown in the teamwork graph.',
	},
	page: {
		id: 'twcg-onboarding-intro-animation.page',
		defaultMessage: 'Page',
		description: 'Page node label shown in the teamwork graph.',
	},
	team: {
		id: 'twcg-onboarding-intro-animation.team',
		defaultMessage: 'Team',
		description: 'Team node label shown in the teamwork graph.',
	},
});
